import { render, staticRenderFns } from "./Stores.vue?vue&type=template&id=4083d456&scoped=true&"
import script from "./Stores.vue?vue&type=script&lang=ts&"
export * from "./Stores.vue?vue&type=script&lang=ts&"
import style0 from "./Stores.vue?vue&type=style&index=0&id=4083d456&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4083d456",
  null
  
)

export default component.exports